module.exports = __webpack_public_path__ + "img/menuDetail6.d22b2b1f.png";